<template>
  <div>
    <!-- <div class="content-header"></div> -->
  <content-header :freezer="true"></content-header>
    <div class="content-wrapper">
      <el-row>
        <el-col :span="24" class="content-right">
          <cooler-list :type="tradeType"></cooler-list>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header.vue';
import coolerList from "./components/cooler-list";

export default {
  name: "trade-order",
  components: {
    coolerList,
    ContentHeader
  },
  data() {
    return {
      tradeType: "" //动态路由后缀
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.getRequest();
      }
    }
  },
  methods: {
    //获取动态路由后缀
    getRequest(val) {
      this.tradeType = this.$route.params.tradeType;
    }
  }
};
</script>

<style lang="scss" scoped>
.sucess-icon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.dialog-text {
  font-size: 15px;
  font-weight: bold;
}

.dialog-data-message {
  width: 50%;
  margin-bottom: 20px;
}
.content-header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}
.trade-nav-panel {
  width: 80%;
  min-height: 400px;
  margin: 0 auto;
  background: $base-white;
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
</style>
<style>
.pagination .el-pagination {
  text-align: center;
}
</style>
